import { getProgressionForApplication } from '@flatsy/utils/Functions/Files/GetApplicationDossierProgression'
import React, { useContext, useEffect, useState } from 'react'
import { LogoAgency } from 'src/utils/LogoAgency'
import { Body1, SubBody2 } from '@flatsy/core/MaterialUi/Typo'
import i18n from '@flatsy/utils/translations'
import { FileContext } from '../../Context'
import { useStyles } from './Style'
import { stepProgression, stepProgressionReturn } from '../Steppers/Utils'

const MobileTopBar: React.FC = (): React.ReactElement => {
  const classes = useStyles()
  const { applicants, files, asset } = useContext(FileContext)
  const [stepperState, setStepperState] = useState<stepProgressionReturn>([
    'incomming',
    'incomming',
    'incomming',
  ])
  useEffect(() => {
    const progression = getProgressionForApplication({
      applicants: applicants.list,
      files: files.list,
    })
    setStepperState(stepProgression({ progression }))
  }, [applicants.list, files.list])

  const stepContent = (): [string, string] => {
    if (stepperState[2] === 'inprogress') {
      return [i18n.t('step_from_to', { current: 3, total: 3 }), i18n.t('final_decision')]
    }
    if (stepperState[1] === 'inprogress') {
      return [i18n.t('step_from_to', { current: 2, total: 3 }), i18n.t('documents_under_review')]
    }

    return [i18n.t('step_from_to', { current: 1, total: 3 }), i18n.t('documents_to_submit')]
  }

  const content = stepContent()

  return (
    <div className={classes.cards}>
      <div className={classes.logoWrapper}>{LogoAgency(classes, asset?.logo_url)}</div>
      <div className={classes.contentContainer}>
        <SubBody2 className={classes.progress}>{content[0]}</SubBody2>
        <Body1 className={classes.name}>{content[1]}</Body1>
      </div>
    </div>
  )
}

export default MobileTopBar
